import React, { useContext } from 'react';
import { FormContext, FormContextType } from '../../../../form/FormContext';
import type { ShareSettingsFormState } from '../../../types';
import { useInternalShareSettings } from '../../hooks/useInternalShareSettings';
import ShareActionFormField from './ShareActionFormField';

export default function ShareDefaultActionFormField() {
    const { shareSettings } = useInternalShareSettings();
    const disabled = shareSettings.accessLevel === 'open';

    const { state, handleChange } = useContext<FormContextType<ShareSettingsFormState>>(FormContext);

    return (
        <ShareActionFormField
            disabled={disabled}
            value={state.defaultAction}
            onChange={(value) => {
                handleChange('defaultAction', value);
            }}
        />
    );
}
